export default __webpack_public_path__ + "static/media/mistake_ex_4@2x.68cdd237.png";